import React, { ReactElement } from 'react';
import StarFillIcon from '../../atoms/icons/StarFillIcon';

interface Props {
  icon?: ReactElement;
  title: string;
}
const CustomNotificationAlert: React.FC<Props> = ({ icon, title }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 11,
      }}
    >
      <>
        {icon ? icon : <StarFillIcon cssStyle={{ marginRight: 6 }} />}
        <span>{title}</span>
      </>
    </div>
  );
};

export default CustomNotificationAlert;
